module.exports = __webpack_public_path__ + "img/7.d6ad89fb.svg";